export const GET_PLAYLISTS_REQUEST = "GET_PLAYLISTS_REQUEST";
export const GET_PLAYLISTS_SUCCESS = "GET_PLAYLISTS_SUCCESS";
export const GET_PLAYLISTS_ERROR = "GET_PLAYLISTS_ERROR";
export const GET_PLAYLISTS_DONE = "GET_PLAYLISTS_DONE";
export const GET_SUBCRIPTIONSTATUS_REQUEST = "GET_SUBCRIPTIONSTATUS_REQUEST";
export const getSubcriptionStatusRequest = (payload) => ({
  type: GET_SUBCRIPTIONSTATUS_REQUEST,
  ...payload,
});
export const getPlaylistsRequest = (payload) => ({
  type: GET_PLAYLISTS_REQUEST,
  ...payload,
});
export const getPlaylistsSuccess = (playlists) => ({
  type: GET_PLAYLISTS_SUCCESS,
  playlists,
});

export const getPlaylistsError = (error) => ({
  type: GET_PLAYLISTS_ERROR,
  error,
});

export const getPlaylistsDone = () => ({
  type: GET_PLAYLISTS_DONE,
});



// WEBPACK FOOTER //
// ./src/pages/playlists/actions.js